<template>
  <div>
    <VTextField
      v-model="internalValue"
      autocomplete
      outlined
      label="Email or Phone"
      name="username"
      :rules="[$store.state.rules.required,$store.state.rules.usernameRules]"
    />
  </div>
</template>

<script>
  // Utilities
  import {
    mapMutations
  } from 'vuex'

  export default {
    name: 'UserName',

    mounted(){
      if(this.internalValue==="" && window.localStorage.getItem('username')){
        this.internalValue = window.localStorage.getItem('username')
        window.localStorage.removeItem('username')
      }
      if(this.$route.query.username){
        this.internalValue = this.$route.query.username
      }
    },

    computed: {
      internalValue: {
        get () {
          return this.$store.state.username
        },
        set (val) {
          this.setUsername(val)
        }
      }
    },

    methods: {
      ...mapMutations(['setUsername'])
    }
  }
</script>
